module.exports = __webpack_public_path__ + "static/media/AZ.15211ca3.svg";